import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import 'animate.css';
import 'fullpage-vue/src/fullpage.css';
import Zendesk from '@dansmaculotte/vue-zendesk'
import VueFullpage from 'fullpage-vue';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faInstagram, faFacebookF } from "@fortawesome/free-brands-svg-icons";
import {
  faChevronLeft,
  faChevronRight,
  faPause,
  faPlay,
  faQuestion,
  faStar,
  faStore, faTimes,
  faUndo
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import VueAwesomeSwiper from "vue-awesome-swiper";
import 'swiper/swiper-bundle.css'
import {VueMasonryPlugin} from "vue-masonry";
import VueMixpanel from 'vue-mixpanel';
library.add(faInstagram, faFacebookF, faQuestion, faStore, faStar, faPlay, faPause, faUndo, faChevronLeft, faChevronRight, faTimes)

Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.use(VueMasonryPlugin)
Vue.use(VueFullpage)
Vue.use(VueAwesomeSwiper, )
Vue.use(Zendesk, {
  key: 'fa263b90-a8bd-4490-b1e0-bdc86fb8f0d2',
  disabled: false,
  hideOnLoad: true,
  settings: {
    webWidget: {
      launcher: {
        mobile: {
          labelVisible: false
        }
      },
    }
  }
})
Vue.use(VueMixpanel, {
  token: '1a113e5fc5cca0dc79e4926f18ac8b8d',
  config: {
    debug: true
  }
})
Vue.config.productionTip = false

new Vue({
  vuetify,
  render: h => h(App)
}).$mount('#app')
